import React from 'react'
import { camelCase, kebabCase } from 'lodash'

import {
  GridContainer,
  IProps as IGridContainerProps,
} from 'marketing-site/src/library/components/GridContainer'
import {
  CONTENT_TYPE,
  IGridContainer as IContentfulGridContainer,
} from 'marketing-site/@types/generated/contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { IBrand, useBrand } from 'marketing-site/src/library/providers/brandProvider'
import { transformCTAWithBackground } from '../elements/ContentfulCTALink'

export const ContentfulGridContainer = (
  gridContainer: IContentfulGridContainer,
): React.ReactElement => {
  const brand = useBrand()
  return (
    <EntryMarker entry={gridContainer}>
      {() => <GridContainer {...transformGrid(gridContainer, brand)} />}
    </EntryMarker>
  )
}

export const transformTitleSize = (titleSize: string): IGridContainerProps['titleSize'] => {
  const formattedSize = kebabCase(titleSize)
  return formattedSize === 'heading-1'
    ? 'heading-1-default'
    : (formattedSize as IGridContainerProps['titleSize'])
}

const transformContent = (body: IContentfulGridContainer['fields']['body'], brand: IBrand) => {
  const filteredBody = body.map((item, index) => {
    const contentTypeId = item.sys.contentType?.sys.id as CONTENT_TYPE
    return renderTransformedComponent(contentTypeId, item, index, brand)
  })
  return filteredBody
}

const transformGrid = (
  { fields }: IContentfulGridContainer,
  brand: IBrand,
): IGridContainerProps => {
  return {
    ...fields,
    eyebrow: fields.eyebrow && fields.eyebrow.trim(),
    title: fields.title && fields.title.trim(),
    layout: fields.layout && (kebabCase(fields.layout) as IGridContainerProps['layout']),
    titleSize:
      fields.titleSize &&
      (transformTitleSize(fields.titleSize) as IGridContainerProps['titleSize']),
    introText: fields.introText && documentToHtmlString(fields.introText),
    cta: fields.cta ? transformCTAWithBackground(fields.cta) : undefined,
    ctaPosition:
      fields.ctaPosition && (kebabCase(fields.ctaPosition) as IGridContainerProps['ctaPosition']),
    bodyGap: fields.bodyGap && (fields.bodyGap.toLowerCase() as IGridContainerProps['bodyGap']),
    body: fields.body && transformContent(fields.body, brand),
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as IGridContainerProps['backgroundColor']),
  }
}
